import React from "react";
import InstitutesList from "./InstitutesList";
import { tutorCount } from "../../../utils/constants";

const Institutes = () => {
  return (
    <div className="institutes">
      <div className="institutes__head">
        <div className="institutes__head__heading">
          The Classplus family is 1 Lakh+ teachers strong
        </div>
        <div className="institutes__head__text">
          Our customers are our foremost priority and we don't leave any efforts in making their lives awesome. Their love and support has made us what we are. We look forward to seeing you in the family and growing together.
        </div>
      </div>
    </div>
  );
};

export default Institutes;
